import type { CompetitionView } from '@ps/web-sports-api-types';
import React from 'react';

import QuickSwitcher from '../QuickSwitcher/QuickSwitcher';

import styles from './CompetitionCard.scss';

type Props = Pick<CompetitionView, 'competitionName' | 'logoUrl'>;

const CompetitionCard: React.FC<Props> = ({ competitionName, logoUrl }) => (
  <div className={styles.wrapper}>
    <QuickSwitcher
      title={
        <>
          {logoUrl ? <img src={logoUrl} alt={competitionName} /> : null}
          {competitionName}
        </>
      }
    />
  </div>
);

export { CompetitionCard };
